import { useSelector } from 'react-redux';
import { OptionEntity } from 'src/store/optionApi';
import { selectOptions } from 'src/store/optionSlice';
import { areItemsUnique } from 'src/util';
import { Button } from 'src/ui/Button';
import { Icon } from 'src/ui/Icon';
import { PageHead } from 'src/ui/patterns/PageHead';

export interface ContentProps {
  setSelectedOption: (option: OptionEntity) => void;
  onCreate: () => void;
}

const Content = ({ setSelectedOption, onCreate }: ContentProps) => {
  const allOptions = useSelector(selectOptions);
  const orderedOptions = Object.values(allOptions).sort((a, b) =>
    a.field.localeCompare(b.field)
  );

  return (
    <div
      className="col"
      style={{ borderRight: '1px solid var(--border)', overflow: 'hidden' }}
    >
      <PageHead
        title="Options"
        count={orderedOptions.length}
        subtitle={`${orderedOptions.length} profile fields`}
        right={
          <Button
            variant="primary"
            size="sm"
            iconOnly
            title="New option set"
            onClick={onCreate}
          >
            <Icon name="plus" size={16} />
          </Button>
        }
      />
      <div className="grow scroll-y" style={{ padding: 6 }}>
        {orderedOptions.map((option) => {
          const isUnique = areItemsUnique(
            option.labels.map((label) => label[0])
          );
          const valueCount = option.labels.length;
          return (
            <div
              key={option.id}
              role="button"
              tabIndex={0}
              className={'list-row' + (!isUnique ? ' danger' : '')}
              onClick={() => setSelectedOption(option)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setSelectedOption(option);
                }
              }}
              style={
                !isUnique
                  ? {
                      background: 'var(--red-subtle)',
                      borderRadius: 'var(--radius-sm)',
                    }
                  : undefined
              }
            >
              <span
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: 'var(--radius-sm)',
                  background: 'var(--bg-muted)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'var(--text-muted)',
                  flexShrink: 0,
                }}
              >
                <Icon name="sliders-horizontal" size={15} />
              </span>
              <div className="grow">
                <div style={{ fontWeight: 500, fontSize: 'var(--fs-sm)' }}>
                  {option.field}
                  {!isUnique && (
                    <span
                      style={{
                        marginLeft: 6,
                        fontSize: 'var(--fs-xs)',
                        color: 'var(--red-solid)',
                        fontWeight: 400,
                      }}
                    >
                      (not unique)
                    </span>
                  )}
                </div>
                <div
                  className="text-muted"
                  style={{ fontSize: 'var(--fs-xs)' }}
                >
                  {valueCount} values
                </div>
              </div>
              <Icon
                name="chevron-right"
                size={15}
                style={{ color: 'var(--text-faint)' }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Content;
